import request from 'local_modules/request'
import moment from 'moment'
import { reducers, getState } from 'redux/core'
import { constants } from 'helpers'


const setFetching = (isFetching) => reducers.heroes.setFetching(isFetching)

const fetch = () => {
  const { me: { cityId } } = getState()

  return request.get(constants.heroes.list + `?cityId=${cityId}`)
    .then(({ data }) => data)
    .then((data) => {
      let _data = data

      if (_data && _data.length) {
        _data = _data.map(({ id, firstName, lastName, middleName, sign, gender, birth, death, description, author_id, ...rest }) => ({
          id,
          firstName,
          lastName,
          middleName,
          sign,
          gender,
          birth: birth ? moment(birth).format('YYYY') : birth,
          death: death ? moment(death).format('YYYY') : death,
          description,
          image: `${constants.heroes.img}?id=${id}`,
          canEdit: author_id === id,
          ...rest,
        }))
      }

      reducers.heroes.setList(_data)
      reducers.heroes.setFetching(false)
    })
    .catch((error) => console.error(error))
}

const add = ({ firstName, lastName, middleName, sign, gender, birth, death, description, image }) => {
  const { me: { cityId } } = getState()

  console.log('add', {
    firstName,
    lastName,
    middleName,
    sign,
    gender,
    birth: birth ? moment(birth, 'YYYY').format('YYYY-MM-DD') : birth,
    death: death ? moment(death, 'YYYY').format('YYYY-MM-DD') : death,
    description,
    image,
  })

  return request.post(constants.heroes.add, {
    cityId,
    firstName,
    lastName,
    middleName,
    sign,
    gender,
    birth: birth ? moment(birth, 'YYYY').format('YYYY-MM-DD') : birth,
    death: death ? moment(death, 'YYYY').format('YYYY-MM-DD') : death,
    description,
    image,
  })
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error)
      return Promise.reject(error)
    })
}

const edit = ({ id, firstName, lastName, middleName, sign, gender, birth, death, description, image }) => {
  const { me: { cityId } } = getState()

  const isSameImage = image.includes(`${constants.heroes.img}?id=`)

  console.log('edit', {
    id,
    firstName,
    lastName,
    middleName,
    sign,
    gender,
    birth: birth ? moment(birth, 'YYYY').format('YYYY-MM-DD') : birth,
    death: death ? moment(death, 'YYYY').format('YYYY-MM-DD') : death,
    description,
    image: isSameImage ? null : image,
  })

  return request.put(constants.heroes.update, {
    id,
    cityId,
    firstName,
    lastName,
    middleName,
    sign,
    gender,
    birth: birth ? moment(birth, 'YYYY').format('YYYY-MM-DD') : birth,
    death: death ? moment(death, 'YYYY').format('YYYY-MM-DD') : death,
    description,
    image: isSameImage ? null : image,
  })
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error)
      return Promise.reject(error)
    })
}

const moderate = (id) => {
  console.log('moderate', { id })

  return request.get(constants.heroes.moderate + `?id=${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error)
      return Promise.reject(error)
    })
}

const handleDelete = (id) => {
  return request.delete(constants.heroes.delete + `/${id}`)
    .then(({ data }) => data)
    .catch((error) => {
      console.error(error)
      return Promise.reject(error)
    })
}


export default {
  setFetching,

  fetch,
  add,
  edit,
  moderate,
  handleDelete,
}
